import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgRefresh} from "~/assets/svg/refresh.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmRefreshIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgRefresh id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
